import React, { useState } from "react";
import {
  Button,
  Card,
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import useCheckoutClassicStyles from "./checkoutClassicStyles";

// Features shown before "See more features".
const VISIBLE_FEATURES = 4;

// Mirrors the reference RegionalPlansPage plan card: MUI Divider (not <hr>),
// MUI List/ListItem/ListItemIcon/ListItemText for the features (their classes
// assume MUI's list structure), and a passActions row whose left side holds the
// planPriceBottom price + GST caption.
export default function PlanCard({
  headline,
  badge,
  subtitle,
  features,
  lineItems = [],
  priceLabel,
  billedLabel,
  gstPct,
  gstLabel,
}) {
  const classes = useCheckoutClassicStyles();
  const [expanded, setExpanded] = useState(false);
  const renderFeatures = (list) => (
    <List className={classes.featureList} dense>
      {list.map((f, i) => (
        <ListItem key={i} className={classes.featureItem}>
          <ListItemIcon className={classes.featureIcon}>
            <CheckIcon className={classes.featureCheck} />
          </ListItemIcon>
          <ListItemText
            primary={f}
            className={classes.featureText}
            primaryTypographyProps={{ style: { fontSize: "13px" } }}
          />
        </ListItem>
      ))}
    </List>
  );
  return (
    <Card className={classes.planCard} elevation={0}>
      <Box className={classes.planHeader}>
        <Typography className={classes.planTitle}>{headline}</Typography>
        {badge ? <span className={classes.planBadge}>{badge}</span> : null}
      </Box>

      {subtitle ? (
        <Typography className={classes.planSubtitle}>{subtitle}</Typography>
      ) : null}

      {/* One row per line item. */}
      {lineItems.length > 0 && (
        <Box>
          <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4 }}>
            What's included
          </Typography>
          <List dense className={classes.featureList}>
            {lineItems.map((li) => (
              <ListItem key={li.id} className={classes.featureItem}>
                <ListItemIcon className={classes.featureIcon}>
                  <CheckIcon className={classes.featureCheck} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Box display="flex" justifyContent="space-between">
                      <span>
                        {li.title}
                        {li.oneTime ? <span className={classes.oneTimeTag}> (one-time)</span> : null}
                      </span>
                      <span>
                        {li.originalLabel ? (
                          <span className={classes.originalPrice}>{li.originalLabel}</span>
                        ) : null}
                        {li.amountLabel}
                      </span>
                    </Box>
                  }
                  className={classes.featureText}
                  primaryTypographyProps={{ style: { fontSize: 13 } }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      )}

      <Divider className={classes.divider} />

      {features.length > 0 && renderFeatures(features.slice(0, VISIBLE_FEATURES))}

      {features.length > VISIBLE_FEATURES && (
        <div>
          <Button
            onClick={() => setExpanded(!expanded)}
            className={classes.seeMoreButton}
            endIcon={expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          >
            {expanded ? "See less" : "See more features"}
          </Button>
          {expanded && renderFeatures(features.slice(VISIBLE_FEATURES))}
        </div>
      )}

      <Divider className={classes.divider} />

      <Box className={classes.passActions}>
        <Box>
          <Typography className={classes.planPriceBottom}>
            {priceLabel}
            {gstPct > 0 && (
              <Typography
                variant="caption"
                style={{ fontSize: "12px", color: "#555", marginLeft: "4px" }}
              >
                +{gstPct}% {gstLabel}
              </Typography>
            )}
          </Typography>
          {billedLabel ? (
            <Typography variant="caption" className={classes.billingPeriodText}>
              {billedLabel}
            </Typography>
          ) : null}
        </Box>
        <span className={classes.planIncluded}>
          <CheckIcon style={{ fontSize: 16 }} /> Included
        </span>
      </Box>
    </Card>
  );
}
